export interface TotalActiveVehiculeCheck {
  vehiculeId?: string;
  actionUserId?: string;
  userId?: string;
  onlyCompleted?: boolean;
}

export enum ActionUserType {
  PROFESSIONAL = 'PROFESSIONAL',
  INDIVIDUAL = 'INDIVIDUAL',
}

export interface AllToModerateVehiculeCheck {
  userId?: string;
  actionUserType?: ActionUserType;
}

export interface AllToValidateVehiculeCheck {
  userId?: string;
  actionUserType?: ActionUserType;
}

export enum VehiculeCheckProgressStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  REQUEST_CREATED = 'REQUEST_CREATED',
  REQUEST_CREATED_AND_SENT = 'REQUEST_CREATED_AND_SENT',
  COMPLETED = 'COMPLETED',
  COMPLETED_STILL_WAITING_FOR_VIDEO = 'COMPLETED_STILL_WAITING_FOR_VIDEO',
  COMPLETED_STILL_WAITING_FOR_CHUNKS = 'COMPLETED_STILL_WAITING_FOR_CHUNKS',
  COMPLETED_STILL_PROCESSING_VIDEO = 'COMPLETED_STILL_PROCESSING_VIDEO',
  COMPLETED_REPORT_AVAILABLE = 'COMPLETED_REPORT_AVAILABLE',
}
